import React from 'react';
import { Activity } from 'lucide-react';
import PageLayout, { PageHero } from './layout/PageLayout';
import SEO from './SEO';

const StatusPage = ({ onBack, onLogin, onRegister }) => (
  <PageLayout onBack={onBack} onLogin={onLogin} onRegister={onRegister}>
    <SEO
      title="Service Status | Lexa.run"
      description="Information about service status reporting and how to report an issue to Lexa."
    />
    <PageHero
      badge={<><Activity className="h-4 w-4" /> Service Status</>}
      title="Need help with"
      titleHighlight="a service issue?"
      subtitle="Live service monitoring is not published on this page yet."
    />
    <section className="px-5 pb-20 sm:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="max-w-2xl rounded-3xl border border-slate-200 bg-white p-8">
          <h2 className="text-xl font-semibold text-slate-950">Report an issue</h2>
          <p className="mt-4 leading-7 text-slate-500">
            We do not currently publish verified uptime measurements or incident
            history here. If something is not working, contact our support team
            with the affected workspace, time, and a description of the issue.
            Please do not include passwords or other secrets.
          </p>
          <a href="mailto:support@lexa.run" className="mt-6 inline-flex text-violet-700 underline underline-offset-4">
            support@lexa.run
          </a>
        </div>
      </div>
    </section>
  </PageLayout>
);

export default StatusPage;
